export const generateSlug = (name) => {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // Remove accents
    .replace(/ç/g, 'c')
    .replace(/[^a-zA-Z0-9\-_]/g, '') // Remove invalid characters
    .replace(/\s+/g, '') // Remove spaces between words
    .replace(/--+/g, '-') // Replace multiple '-' with a single '-'
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing '-'
};